import React from 'react';
import { LegalPage } from '../components/legal/LegalPage';

const sections = [
  {
    heading: '1. Éditeur du site',
    blocks: [
      { type: 'p', content: "Conformément aux dispositions de la loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique, il est précisé aux utilisateurs du site www.mmd-conseils.fr l'identité des différents intervenants dans le cadre de sa réalisation et de son suivi." },
      { type: 'p', content: "Éditeur du site :\nMMD CONSEIL\nSociété d'Expertise Comptable\nSIREN : 988 117 248" },
      { type: 'p', content: "Siège social :\n220 Avenue Victor Hugo\n69140 Rillieux-la-Pape\nFrance" },
      { type: 'p', content: "Téléphone : 06 67 30 88 94\nE-mail : contact@mmd-conseils.fr" },
      { type: 'p', content: "Directeur de la publication :\nMakhan Diallo, Expert-Comptable" },
      { type: 'p', content: "Responsable de la publication :\nMakhan Diallo\ncontact@mmd-conseils.fr" },
      { type: 'p', content: "Création et développement :\nMMD CONSEIL" },
      { type: 'p', content: "Hébergement :\nOVHcloud\n2 rue Kellermann\n59100 Roubaix – France" },
    ],
  },
  {
    heading: "2. Conditions générales d'utilisation",
    blocks: [
      { type: 'p', content: "L'utilisation du site www.mmd-conseils.fr implique l'acceptation pleine et entière des présentes conditions générales d'utilisation." },
      { type: 'p', content: "Ces conditions d'utilisation sont susceptibles d'être modifiées ou complétées à tout moment. Les utilisateurs du site sont donc invités à les consulter régulièrement." },
      { type: 'p', content: "Le site est normalement accessible à tout moment aux utilisateurs. Une interruption pour raison de maintenance technique peut toutefois être décidée par MMD CONSEIL." },
    ],
  },
  {
    heading: '3. Description des services fournis',
    blocks: [
      { type: 'p', content: "Le site www.mmd-conseils.fr a pour objet de présenter les activités du cabinet MMD CONSEIL et de fournir des informations relatives à ses prestations, notamment :" },
      { type: 'list', content: [
        "Expertise comptable",
        "Conseil aux entreprises",
        "Gestion sociale et paie",
        "Accompagnement fiscal",
        "Assistance juridique courante",
        "Création, reprise et développement d'entreprise",
      ] },
      { type: 'p', content: "MMD CONSEIL s'efforce de fournir sur son site des informations aussi précises que possible. Toutefois, il ne pourra être tenu responsable des omissions, inexactitudes ou carences dans la mise à jour des informations diffusées." },
      { type: 'p', content: "Les informations figurant sur le site sont fournies à titre indicatif et sont susceptibles d'évoluer." },
    ],
  },
  {
    heading: '4. Limitations contractuelles sur les données techniques',
    blocks: [
      { type: 'p', content: "Le site utilise les technologies web actuelles, notamment JavaScript." },
      { type: 'p', content: "L'utilisateur s'engage à accéder au site avec un matériel récent, exempt de virus et avec un navigateur régulièrement mis à jour." },
      { type: 'p', content: "MMD CONSEIL ne pourra être tenu responsable des dommages matériels liés à l'utilisation du site." },
    ],
  },
  {
    heading: '5. Propriété intellectuelle',
    blocks: [
      { type: 'p', content: "L'ensemble des éléments composant le site (textes, photographies, illustrations, logos, graphismes, vidéos, documents téléchargeables, architecture du site, etc.) est protégé par les dispositions du Code de la propriété intellectuelle." },
      { type: 'p', content: "MMD CONSEIL est propriétaire ou titulaire des droits d'utilisation de l'ensemble des éléments accessibles sur le site." },
      { type: 'p', content: "Toute reproduction, représentation, modification, publication, adaptation ou exploitation, totale ou partielle, des éléments du site, quel que soit le procédé utilisé, est interdite sans l'autorisation écrite préalable de MMD CONSEIL." },
      { type: 'p', content: "Toute utilisation non autorisée pourra faire l'objet de poursuites conformément aux dispositions du Code de la propriété intellectuelle." },
    ],
  },
  {
    heading: '6. Limitation de responsabilité',
    blocks: [
      { type: 'p', content: "MMD CONSEIL ne pourra être tenu responsable des dommages directs ou indirects causés au matériel de l'utilisateur lors de l'accès au site." },
      { type: 'p', content: "MMD CONSEIL se réserve le droit de supprimer, sans préavis, tout contenu déposé via un formulaire ou un espace interactif qui contreviendrait à la législation française ou porterait atteinte à l'ordre public." },
    ],
  },
  {
    heading: '7. Protection des données personnelles',
    blocks: [
      { type: 'p', content: "MMD CONSEIL attache une importance particulière à la protection des données personnelles." },
      { type: 'p', content: "Les informations recueillies via les formulaires du site sont destinées exclusivement à :" },
      { type: 'list', content: [
        "Répondre aux demandes des utilisateurs",
        "Assurer le suivi des prospects et clients",
        "Fournir les prestations sollicitées",
        "Respecter les obligations légales et réglementaires applicables",
      ] },
      { type: 'p', content: "Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, chaque utilisateur dispose des droits suivants :" },
      { type: 'list', content: [
        "Droit d'accès",
        "Droit de rectification",
        "Droit d'effacement",
        "Droit d'opposition",
        "Droit à la limitation du traitement",
        "Droit à la portabilité des données",
      ] },
      { type: 'p', content: "Toute demande relative à l'exercice de ces droits peut être adressée à :" },
      { type: 'p', content: "MMD CONSEIL\n220 Avenue Victor Hugo\n69140 Rillieux-la-Pape\nFrance" },
      { type: 'p', content: "Ou par e-mail à : contact@mmd-conseils.fr" },
      { type: 'p', content: "Les données personnelles ne sont ni vendues, ni cédées, ni transmises à des tiers à des fins commerciales." },
    ],
  },
  {
    heading: '8. Cookies',
    blocks: [
      { type: 'p', content: "La navigation sur le site peut entraîner l'installation de cookies sur le terminal de l'utilisateur." },
      { type: 'p', content: "Ces cookies ont pour finalité :" },
      { type: 'list', content: [
        "D'améliorer l'expérience utilisateur",
        "D'assurer le bon fonctionnement du site",
        "De mesurer l'audience du site",
      ] },
      { type: 'p', content: "L'utilisateur peut configurer son navigateur afin de refuser tout ou partie des cookies." },
      { type: 'p', content: "Le refus de certains cookies peut toutefois altérer le fonctionnement de certaines fonctionnalités du site." },
    ],
  },
  {
    heading: '9. Liens hypertextes',
    blocks: [
      { type: 'p', content: "Le site peut contenir des liens vers des sites internet tiers." },
      { type: 'p', content: "MMD CONSEIL ne dispose d'aucun contrôle sur le contenu de ces sites et ne saurait être tenu responsable des informations qui y sont diffusées." },
    ],
  },
  {
    heading: '10. Droit applicable et juridiction compétente',
    blocks: [
      { type: 'p', content: "Les présentes mentions légales sont régies par le droit français." },
      { type: 'p', content: "Tout litige relatif à l'utilisation du site www.mmd-conseils.fr sera soumis à la compétence exclusive des tribunaux territorialement compétents du ressort de la Cour d'appel de Lyon." },
    ],
  },
  {
    heading: '11. Profession réglementée',
    blocks: [
      { type: 'p', content: "MMD CONSEIL exerce la profession d'Expert-Comptable réglementée par :" },
      { type: 'list', content: [
        "L'Ordonnance n°45-2138 du 19 septembre 1945",
        "Le Code de déontologie des professionnels de l'expertise comptable",
        "Les normes professionnelles applicables à la profession",
      ] },
      { type: 'p', content: "Le cabinet est inscrit au Tableau de l'Ordre des Experts-Comptables et soumis au contrôle de cette institution professionnelle." },
    ],
  },
  {
    heading: '12. Médiation de la consommation',
    blocks: [
      { type: 'p', content: "Conformément aux articles L.612-1 et suivants du Code de la consommation, tout consommateur a le droit de recourir gratuitement à un médiateur de la consommation en vue de la résolution amiable d'un litige qui l'opposerait à MMD CONSEIL." },
      { type: 'p', content: "Les coordonnées du médiateur compétent seront communiquées sur simple demande." },
    ],
  },
];

const MentionsLegales = () => (
  <LegalPage
    title="Mentions légales"
    intro="Informations légales relatives au site www.mmd-conseils.fr et au cabinet MMD CONSEIL."
    seoDescription="Mentions légales de MMD CONSEIL : éditeur, hébergeur, propriété intellectuelle, données personnelles et profession réglementée d'expert-comptable."
    path="/mentions-legales"
    sections={sections}
  />
);

export default MentionsLegales;
